export const MuiStep = {
  styleOverrides: {
    root: {
      '&.MuiStep-root:first-of-type': {
        paddingLeft: '0px',
      },
      '&.MuiStep-root:last-of-type': {
        paddingRight: '0px',
      },
    },
  },
}
